import React from 'react'
import {
  CFView,
  CFImage,
  CFLink,
  DefaultScreen,
  MobileScreen,
} from 'components'
import Header from './Header'
import OrderPickupButton from './OrderPickupButton'
import OrderDeliveryButton from './OrderDeliveryButton'
import {
  downloadAppButton,
  hero,
  heroText,
  logo,
  mobileHero,
  mobileHeroText,
} from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView
          h="100VH"
          w="100%"
          image={`url(${mobileHero}) bottom / cover no-repeat`}
          boxShadow="0 2px 2px rgba(0,0,0,.5)"
        >
          <CFView column center alignCenter>
            <CFImage src={mobileHeroText} w="85vw" alt="About" mt="50px" />
            <CFView column justifyBetween alignCenter ph="10px">
              <CFView mt="30px" pulsate>
                <OrderPickupButton />
              </CFView>
              {/* <OrderDeliveryButton /> */}
            </CFView>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          h="100vh"
          maxHeight="700px"
          w="100%"
          maxWidth="1400px"
          image={`url(${hero}) right / cover no-repeat`}
          boxShadow="0 2px 5px rgba(0,0,0,.5)"
          zIndex={90}
        >
          <CFView
            h="100vh"
            maxHeight="700px"
            column
            justifyCenter
            alignEnd
            mr="8%"
          >
            <CFView column justifyCenter alignStart>
              <CFImage
                src={heroText}
                w="43vw"
                maxWidth="650px"
                alt="About"
                mb="30px"
              />
              <CFView pulsate>
                <OrderPickupButton />
              </CFView>
            </CFView>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
